import { useIsMobile } from "../../hooks/useIsMobile";
import { Mobile } from "./mobile";
import { Desktop } from "./desktop";
import styles from "./index.module.scss";

interface HomeProps {
    id?: string;
}

export const Home = ({ id }: HomeProps) => {
    const isMobile = useIsMobile();

    return (
        <div className={styles.home} id={id}>
            {isMobile ? <Mobile/> : <Desktop/>}
        </div>
    );
};